import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage, KeyValueStorageInterface } from 'aws-amplify/utils';

import { BTF_DOMAIN, SESSION_COOKIES_TIMEOUT } from '../shared/constants/auth';
import {
  AMPLIFY_COOKIES_KEY_END_ACCESS_TOKEN,
  AMPLIFY_COOKIES_KEY_START,
  IS_NOT_LOCAL
} from '../shared/constants/constants';

export const COGNITO_CONFIG = {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID
};

export const COGNITO_OAUTH_CONFIG = {
  domain: import.meta.env.VITE_COGNITO_DOMAIN_URL,
  scopes: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
  redirectSignIn: [import.meta.env.VITE_PORTAL_LOGIN_REDIRECT_URL],
  redirectSignOut: [import.meta.env.VITE_PORTAL_LOGOUT_REDIRECT_URL],
  responseType: 'code' as const
};

export const AMPLIFY_AUTH_CONFIG = {
  Auth: {
    Cognito: COGNITO_CONFIG
  }
};

export const AMPLIFY_AUTH_CONFIG_WITH_OAUTH = {
  Auth: {
    Cognito: {
      ...COGNITO_CONFIG,
      loginWith: {
        oauth: COGNITO_OAUTH_CONFIG
      }
    }
  }
};

export const cookieStorage = new CookieStorage({
  domain: String(BTF_DOMAIN),
  secure: IS_NOT_LOCAL,
  path: '/',
  expires: SESSION_COOKIES_TIMEOUT
});

const storeInCookies = (key: string) => {
  return key.startsWith(AMPLIFY_COOKIES_KEY_START) && !key.endsWith(AMPLIFY_COOKIES_KEY_END_ACCESS_TOKEN);
};

export const dividedStorage: KeyValueStorageInterface = {
  async getItem(key: string): Promise<string | null> {
    if (storeInCookies(key)) {
      return cookieStorage.getItem(key);
    }
    return sessionStorage.getItem(key);
  },

  async setItem(key: string, value: string): Promise<void> {
    if (storeInCookies(key)) {
      cookieStorage.setItem(key, value);
    } else {
      sessionStorage.setItem(key, value);
    }
  },

  async removeItem(key: string): Promise<void> {
    if (storeInCookies(key)) {
      cookieStorage.removeItem(key);
    } else {
      sessionStorage.removeItem(key);
    }
  },

  async clear(): Promise<void> {
    cookieStorage.clear();
    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith(AMPLIFY_COOKIES_KEY_START)) {
        sessionStorage.removeItem(key);
      }
    });
  }
};

cognitoUserPoolsTokenProvider.setKeyValueStorage(dividedStorage);

export const configureAmplify = (config = AMPLIFY_AUTH_CONFIG) => {
  Amplify.configure(config);
};

export const configureAmplifyStandard = () => {
  configureAmplify(AMPLIFY_AUTH_CONFIG);
};

export const configureAmplifyWithOAuth = () => {
  configureAmplify(AMPLIFY_AUTH_CONFIG_WITH_OAUTH);
};
